export const IMMEDIATE = "immediate";
export const BILL_TO_ACCOUNT = "bill to account";
export const BOTH_OPTIONS = "both options";
